import { useEffect, useState } from 'react'

/**
 * État de connectivité déclaré par le navigateur.
 *
 * ⚠ `navigator.onLine === true` prouve seulement qu'une interface réseau est
 * active : un wifi capté sans passerelle le renvoie aussi. La source de vérité
 * reste l'état d'erreur des requêtes ; ce hook ne sert qu'à afficher un indice.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  )

  useEffect(() => {
    const handleOnline = () => setOnline(true)
    const handleOffline = () => setOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return online
}
